"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _textmedia_1 = require("./_textmedia");
// Legacy alias of `rich-text` (now "Text & image"). Kept registered so existing
// stores keep rendering, but hidden from the Add-section picker to avoid a
// duplicate — one section does both jobs.
(0, manifest_1.registerSection)({
    type: 'image-with-text', label: 'Image with text', icon: 'panels-top-left', category: 'content',
    hidden: true,
    settingsSchema: zod_1.z.object({ ..._textmedia_1.textMediaShape }),
    defaults: () => ({ ...(0, _textmedia_1.textMediaDefaults)(), imageLayout: 'left' }),
    fields: _textmedia_1.textMediaFields,
});
//# sourceMappingURL=image-with-text.js.map